import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CianMortgageBanner } from '../../../components/NewbuildingMortgageSection/components/CianMortgageBanner';
import { banksListSelector, selectRandomBankList } from '../../../selectors';
import { useApplicationContext } from '../../ApplicationContext';
import { formatBannerPayment, getCianMortgageBannerUrl } from '../helpers';
import { trackMortgageBannerClick, trackMortgageBannerShow } from '../tracking';

export interface ICianMortgageBannerContainerProps {
  monthlyPayment: number;
}

export const CianMortgageBannerContainer: React.FC<React.PropsWithChildren<ICianMortgageBannerContainerProps>> = ({
  monthlyPayment,
}) => {
  const banks = useSelector(banksListSelector);
  const randomBanks = useSelector(selectRandomBankList);

  const { config } = useApplicationContext();
  const bannerUrl = getCianMortgageBannerUrl(config);

  return (
    <ActionAfterViewObserver callback={trackMortgageBannerShow} triggerOnce>
      <CianMortgageBanner
        onClick={trackMortgageBannerClick}
        monthlyPayment={formatBannerPayment(monthlyPayment)}
        url={bannerUrl}
        randomBanks={randomBanks}
        banks={banks}
      />
    </ActionAfterViewObserver>
  );
};
